<template>
  <div :class="cssClass">
    <iframe
      :allow="allow"
      :id="app"
      :src="url"
      class="iframe-integration"
      @load="load"
    ></iframe>
  </div>
</template>

<script>
import { appUrl } from '../app-settings/appUrls';

export default {
  props: {
    app: {
      type: String,
      required: true,
    },
    path: {
      type: String,
      required: false,
      default: '/admin',
    },
    params: {
      type: URLSearchParams,
      required: false,
      default: function () {
        return new URLSearchParams();
      },
    },
    allow: {
      type: String,
      required: false,
      default: '',
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    load() {
      this.$emit('load');
    },
  },
  computed: {
    url() {
      return `${appUrl(this.app, this.path)}?${this.params}`;
    },
    cssClass() {
      const classes = ['container'];
      if (this.fullWidth) {
        classes.push('container__full_width');
      }
      if (this.params.get('resize') === 'true') {
        classes.push('container__resize');
      }
      return classes.join(' ');
    },
  },
};
</script>

<style scoped>
.container {
  height: 95vh;
  overflow: hidden;
  padding-top: 56.25%;
  position: relative;
}

.container__full_width {
  max-width: 100%;
}

.container__resize {
  overflow: unset;
}

.iframe-integration {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
